import type { StepId } from '@epilot/journey-logic-commons/src/types/next'
import { z } from 'zod'

import { selectStepsSorted } from '../selectors/config'
import type { HistoryStackChangedAction } from '../types/actions'

import { actionFactory } from './factory'

export const ContextualDataSchema = z.record(z.string(), z.string()).optional()

export const historyStackChanged = actionFactory<HistoryStackChangedAction>(
  (state, { stack }) => {
    if (!stack.length) return

    const sortedSteps = selectStepsSorted(state)

    state.navigatedPath = stack.reduce<StepId[]>((acc, h) => {
      const stepId = sortedSteps[h.stepIndex]?.id

      if (typeof stepId !== 'undefined') {
        acc.push(stepId)
      } else {
        // eslint-disable-next-line no-console
        console.warn('Invalid step index in history stack', {
          wanted: h.stepIndex,
          existing: {
            start: sortedSteps.length ? 0 : undefined,
            end: sortedSteps.length - 1
          }
        })
      }

      return acc
    }, [])
  },
  'historyStackChanged'
)
